import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Component/Navbar/Navbar";
import UpperNavbar from "./Component/Navbar/UpperNavbar";
import Doctors from "./Component/Doctors/Doctors";
import DoctorAppointment from "./Component/Doctors/DoctorAppointment";
import DoctorCheckOut from "./Component/Doctors/DoctorCheckOut";
import MyAppointments from "./Component/Appointments/MyAppointments";
import Login from "./Component/Login/Login";
import Register from "./Component/register/Register";
import PaymentSuccessPage from "./Component/PaymentSucessPage/PaymentSuccessPage";
import PatientProfile from "./Component/PatientProfile/PatientProfile";
import DoctorDashboard from "./Component/DoctorDashboard/DoctorDashboard";
import SessionTimeout from "./Component/SessionTimeout";
import ProtectedRoute from "./Component/ProtectedRoutes/ProtectedRoutes";
import CrmDashboard from "./Component/CRMDashboard/CrmDashboard";
import CrmLogin from "./Component/CRMDashboard/CrmLogin";
import Footer from "./Component/Footer/Footer";
import ScrollTop from "./Component/files/ScrollTop";
import Disclaimer from "./Component/Disclaimer/Disclaimer";
import PrivacyPolicy from "./Component/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./Component/TermsConditions/TermsConditions";
import CancellationRefundPolicy from "./Component/RefundCancellation/RefundCancellation";
import CallNowButton from "./Component/CallNowButton/CallNowButton";
import GrievancePolicy from "./Component/GrievancePolicy/GrievancePolicy";
import RecaptchaPolicy from "./Component/Recaptcha/RecaptchaPolicy";
import EmergencyPlugin from "./Component/EmergencyPlugin/EmergencyPlugin";
import DoctorLogin from "./Component/DoctorDashboard/DoctorLogin";
import ZoomMeeting from "./Component/ZoomMeeting";
import OpdTable from "./Component/OpdTable/OpdTable";
import { useSelector } from "react-redux";
import MarketingLogin from "./Component/Marketing/Login/Login";
import HomeDashboard from "./Component/Marketing/HomeDasboard.tsx/HomeDashboard";
import Home from "./Component/Marketing/HomeDasboard.tsx/Home";
import PageUnderDevelopment from "./Component/Marketing/Pages/NoPageRoutes/PageUnderDevelopment";
import DoctorProfiles from "./Component/Marketing/Pages/DoctorListProfiles/DoctorProfiles";
import { ToastContainer } from "react-toastify";
import DoctorAuditTrail from "./Component/Marketing/Pages/Audit/DoctorProfileAudit/DoctorProfileAudit";
import CreateDoctorProfile from "./Component/Marketing/Pages/AddNewDoctor/NewDoctor";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import VideocallMedicationByDoctorEMR from "./Component/DoctorDashboard/EMR";
import OPDPrescriptionEMR from "./Component/DoctorDashboard/EMR";
import LeftSidePlugins from "./Component/LeftSidePlugins/LeftSidePlugins";
const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
// In App.tsx


function App(){
  return (
        <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
    <Router>
      <AppContent/>
    </Router>
     </GoogleReCaptchaProvider>
  );
}

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const userType = sessionStorage.getItem("userType");
  const isPublicUser = userType !== "D" && userType !== "C";
  const isPatient = userType === "P";
   const isLoginModalOpen = useSelector((state: any) => state.isLoginModalOpen);
   const isSignupModalOpen = useSelector((state: any) => state.isSignupModalOpen);
  const hideNavbarRoutes = ["/crmLogin","/doctorLogin","/marketingLogin","/Login"];
  const hideFooterRoutes = [
    "/crmLogin",
    "/Login",
    "/doctorLogin",
    "/CRMDashboard",
    "/doctorDashboard",
    "/marketingLogin"
  ];
  const isDashboard = location.pathname.startsWith("/dashboard");
  
const shouldShowFooter =
  !hideFooterRoutes.includes(location.pathname) && !isDashboard;
    const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname)|| isDashboard;

  useEffect(() => {
    if (location.pathname === "/"){
      if (userType === "P") {
        return;
      } else if (userType === "D") {
        navigate("/doctorLogin");
      } else if (userType === "C") {
        navigate("/crmLogin");
      } else if ((userType === "D" || userType === "C")){
        sessionStorage.clear();
        sessionStorage.clear();
        if (userType === "D") navigate("/doctorLogin");
        if (userType === "C") navigate("/crmLogin");
      }
    }
  }, [location.pathname, userType, navigate]);


  
  return (
    <>
   <ToastContainer 
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop
  closeOnClick
  pauseOnHover
  draggable
  theme="light"
  toastStyle={{
    fontSize: "12px",
    padding: "4px 16px",
    zIndex: 99999, 
  }}
  style={{
    zIndex: 99999, 
  }}
/>

      {/* {(isPublicUser && !shouldHideNavbar)  && <Navbar />} */}
      {(isPublicUser && !shouldHideNavbar)  && <UpperNavbar />}
      {/* {(isPublicUser && !shouldHideNavbar)  && <CallNowButton />} */}
      {(isPublicUser && !shouldHideNavbar)  && <EmergencyPlugin />}
   {(isPublicUser && !shouldHideNavbar)  && <LeftSidePlugins />}
      <SessionTimeout />
      <ScrollTop />
      {isLoginModalOpen && <Login />}

      {isSignupModalOpen && <Register />}
      <Routes>
        {isPublicUser && (
          <>
            <Route path="/" element={<Doctors/>} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route
              path="/refund_and_cancellation"
              element={<CancellationRefundPolicy />}
            />
            <Route path="/terms_conditions" element={<TermsAndConditions />} />
            <Route
              path="/doctor/:locationName/:speciality/:doctorName"
              element={<DoctorAppointment />}
            />
<Route path="/doctors/:specialization" element={<Doctors />} />
<Route path="/doctors/location/:location" element={<Doctors />} />
<Route path="/doctors/:location/:specialization" element={<Doctors />} />
            <Route path="/doctors" element={<Doctors />} />
            <Route path="/table" element={<OpdTable />} />
            <Route path="/grievance" element={<GrievancePolicy />} />
            <Route path="/recaptcha" element={<RecaptchaPolicy />} />
          </>
        )}

        {isPatient && (
          <>
            <Route path="/profile" element={<PatientProfile />} />
            <Route
              path="/doctors-booking-appointment"
              element={<DoctorCheckOut />}
            />
            <Route path="/myappointments" element={<MyAppointments />} />
            <Route
              path="/booking-confirmation"
              element={<PaymentSuccessPage />}
            />
          </>
        )}

        <Route path="/doctorLogin" element={<DoctorLogin />} />
        <Route path="/crmLogin" element={<CrmLogin />} />
<Route path="/Login" element={<MarketingLogin />} />
       
        <Route path="/dashboard" element={<HomeDashboard />}>
          <Route index element={<Home />} />
          <Route path="/dashboard/profiles" element={<DoctorProfiles />} />


          
          <Route path="/dashboard/new-doctor-profile" element={<CreateDoctorProfile />} />

          
                {/* <Route path="/dashboard/doctor-audit" element={<DoctorAuditTrail />} /> */}

        </Route>
        

        <Route element={<ProtectedRoute allowedUserType="D" />}>
          <Route path="/doctorDashboard" element={<DoctorDashboard />} />
                    <Route path="/dashboard/emr" element={<OPDPrescriptionEMR />} />

        </Route>
        <Route element={<ProtectedRoute allowedUserType="C" />}>
          <Route path="/CRMDashboard" element={<CrmDashboard />} />
        </Route>
           <Route path="*" element={<PageUnderDevelopment />} />
      </Routes>
      {shouldShowFooter && <Footer />}
    </>
  );
}

export default App;
